export default {
  participants: (orgId, eventId) => ['org', orgId, 'event', eventId, 'participants'],
  participant: (orgId, eventId, participantId) => ['org', orgId, 'event', eventId, 'participants', participantId],
}
